import React from 'react';
import { Anchor, Text, Footer } from 'grommet';

export const FooterComponent = () => (
  <Footer pad="medium" alignSelf="center" align="center">
    <Text size="small">
      &copy; {new Date().getFullYear()} Copyright State AutoMobile Mutual Insurance Company.
      All rights reserved.
      <Anchor
        color="#041E41"
        label=" Privacy Policy."
        href="https://www.stateauto.com/privacy"
      />
      <Anchor
        color="#041E41"
        label=" Terms of Use."
        href="https://www.stateauto.com/terms"
      />
    </Text>
  </Footer>
);
